import {
  trigger,
  animate,
  transition,
  style,
  query,
} from "@angular/animations";
export const cartAnimation = trigger("myAnimation", [
  transition(":enter", [
    style({ transform: "translateY(-100%)" }),
    animate("500ms ease-in", style({ transform: "translateY(0%)" })),
  ]),
  transition(":leave", [
    style({ transform: "translateY(0)", opacity: 1 }),
    animate("500ms", style({ transform: "translateY(-100%)", opacity: 0 })),
  ]),
]);
